import React, { useEffect, useState} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import ProtectedRoute from "./routes/ProtectedRoute";
import { useUser } from "./context/UserContext";
import utils from "./utils/Utils";
// import { PageState } from './PageState.ts';
import Navigation from './layout/Navigation';
import Home from './pages/Home';
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Facebook from './pages/Facebook';
import Chat from './pages/Chat';
import YouTubeVideo from './pages/YouTube';
import Profile from "./pages/Profile";
import './App.css';

function App() {
    const { user, setUser } = useUser();
    const [currentPage, setCurrentPage] = useState('');
    // const [pageState, setPageState] = useState(PageState.HOME);
    
    // // need to add @types and rename .js to .ts
    // // npm install —save-dev @types/react @types/react-dom
    // const routePage = () => {
    //   console.log(PageState.HOME);

    //   switch(pageState) {
    //     case PageState.HOME:
    //       return <Home />;
    //     case PageState.FACEBOOK:
    //       return <Facebook />;
    
    //     case PageState.LOGIN:
    //       return <Login setPageState={setPageState} />;
    //     case PageState.SIGNUP:
    //       return <Signup setPageState={setPageState} />;

    //     case PageState.CHAT:
    //       return <Chat />;
    //     case PageState.YOUTUBE:
    //       return <YouTubeVideo />;
    //     case PageState.PROFILE:
    //       return <Profile />;
        
    //     default:
    //       return <Home />;
    //   }
    // }

    const renderPage = () => {
        if (!user.authenticated) {
            switch (currentPage) {
                case 'home':
                    return <Home />;

                case 'facebook':
                    return <Facebook />;
                case 'login':
                    return <Login setCurrentPage={setCurrentPage} />;
                case 'signup':
                    return <Signup setCurrentPage={setCurrentPage} />;

                case 'forgotPassword':
                    return <ForgotPassword setCurrentPage={setCurrentPage} />;

                default:
                    return <Home />;
            }

        } else if (!user.is_verified && currentPage !== 'profile') {
            // console.log('toast');
            utils.toastVerify(`When you signed up, an verification email has been sent to you`);

            setCurrentPage('profile');
            return <Profile />;

        } else {
            switch (currentPage) {
                case 'home':
                    return <Home />;

                case 'facebook':
                    return <Facebook />;
                case 'chat':
                    return <Chat />;

                case 'youtube':
                    return <YouTubeVideo />;

                case 'profile':
                    return <Profile />;
                
                default:
                    return <Home />;
            }
        }
    };

    useEffect(() => {
        // console.log(user);
        // console.log(user?.currentPage);
        if (user?.currentPage) {
            setCurrentPage(user?.currentPage);
        }
    }, []);

    useEffect(() => {
        let thisPage = currentPage;

        if (thisPage === '') {
            if (user?.currentPage) {
                thisPage = user?.currentPage;
            } else {
                thisPage = 'home';
            }
            // console.log(thisPage);
            setCurrentPage(thisPage);
            return;
        }
        
        // console.log(thisPage);
        setUser((profile) => ({
            ...profile,
            currentPage: thisPage,
        }));
    }, [currentPage]);

    return (
        <Router>
            <Routes>
                <Route path="/" element={
                    <>
                        <Navigation setCurrentPage={setCurrentPage} />
                        <main>
                            {renderPage()}
                        </main>
                    </>
                } />
                <Route path="/jshome" element={<Facebook />} />
                <Route path="/verify-email" element={<VerifyEmail setCurrentPage={setCurrentPage} />} />
                <Route path="/reset-password" element={<ResetPassword setCurrentPage={setCurrentPage} />} />
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
        // <Router>
        //   <Routes>
        //     {/* Public Routes */}
        //     <Route path="/" element={<Home />} />
        //     <Route path="/facebook" element={<Facebook />} />
        //     <Route path="/login" element={<Login />} />
        //     <Route path="/signup" element={<Signup />} />

        //     {/* Protected Routes */}
        //     <Route element={<ProtectedRoute />}>
        //       <Route path="/chat" element={<Chat />} />
        //       <Route path="/youtube" element={<YouTubeVideo />} />
        //       <Route path="/profile" element={<Profile />} />
        //     </Route>

        //     {/* Catch-all route for unknown paths */}
        //     {/* <Route path="*" element={<Navigate to="/login" replace />} /> */}
        //     <Route path="*" element={<Navigate to="/" replace />} />

        //     {/* Catch-all route for unknown paths */}
        //     {/* <Route path="*" element={<NotFound />} /> */}
        //   </Routes>
        // </Router>
    );
}

export default App;

